import styled from 'styled-components';
import { MarkdownViewer } from '../MarkdownViewer';
import { breakpoints } from 'design-system/src/tokens/breakpoints';

const StyledPrivacyPolicy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  h1 strong {
    font-family: 'Space Grotesk', system-ui, Helvetica, Arial, sans-serif;
  }

  @media (max-width: ${breakpoints.mobileMax}px) {
    h1 {
      font-size: 1.25rem;
    }
  }
`;

/**
 * Displays all the privacy documents together.
 */
export const PrivacyPolicy = ({ fileNames = [], className }: { fileNames?: string[]; className?: string }) => {
  return (
    <StyledPrivacyPolicy className={className ? className : ''}>
      {fileNames.map((fileName: string) => (
        <MarkdownViewer fileUrl={`/signup/documents/${fileName}`} key={`user-agreement-${fileName}`} />
      ))}
    </StyledPrivacyPolicy>
  );
};
